import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';
import {Avatar, Button, Collapse, List, Space, Modal} from 'antd';
import _ from 'lodash';

import {CloseOutlined, UserOutlined, TeamOutlined} from '@/icons';

import styles from './SelectedPanel.module.less';
import {PageGrid} from '@/component';
import {getColumns} from './tabPane/userListColumns';
import UserViewModal from '@/page/admin/DepartsPage/UserViewModal';

const TYPES = {
    users: '员工',
    groups: '团队',
    departs: '部门',
};

export default function SelectedPanel({selectedValues = {}, onDeleteSelected}) {
    const tableRef = useRef();
    const viewRef = useRef();
    const [groupUrl, setGroupUrl] = useState(null);
    const [visible, setVisible] = useState(false);
    const groupColumns = getColumns(['avatar', 'cwid', 'cName', 'eName', 'extId'], {onNameClick});
    console.log('eeee', selectedValues);

    function onNameClick(record) {
        return () => {
            viewRef.current.showModal(record);
        };
    }

    function onDeleteClick(type, id) {
        return () => {
            onDeleteSelected(type, id);
        };
    }

    function renderIcon(type) {
        if (type === 'users') {
            return <UserOutlined />;
        }
        if (type === 'groups') {
            return <TeamOutlined />;
        }
        if (type === 'departs') {
            return <TeamOutlined />;
        }
        return null;
    }

    function renderItem(type) {
        // eslint-disable-next-line react/display-name
        return item => {
            const {id, name, extId} = item;

            const actions = [
                <Button
                    key="delete"
                    type="text"
                    className={styles.closeBtn}
                    icon={<CloseOutlined className={styles.closeIcon} />}
                    onClick={onDeleteClick(type, id)}
                />,
            ];

            return (
                <List.Item actions={actions} className={styles.item}>
                    <Space className={styles.itemInner}>
                        <Avatar
                            icon={renderIcon(type)}
                            size={24}
                            style={{cursor: type === 'groups' && 'pointer'}}
                            onClick={() => {
                                if (type === 'groups') {
                                    setGroupUrl(`/reportLine/list/${extId}`);
                                    setVisible(true);
                                }
                            }}
                        />
                        <span>{name}</span>
                    </Space>
                </List.Item>
            );
        };
    }

    function renderValues(type, values) {
        if (_.isEmpty(values)) {
            return null;
        }
        console.log(2222, type, values);

        return (
            <Collapse.Panel key={type} header={`已选${TYPES[type]}`}>
                <List
                    size="small"
                    dataSource={values}
                    renderItem={renderItem(type)}
                    className={styles.list}
                />
            </Collapse.Panel>
        );
    }

    const types = Object.keys(TYPES);

    return (
        <>
            <Collapse ghost defaultActiveKey={types}>
                {types.map(type => {
                    const values = _.get(selectedValues, type);
                    return renderValues(type, values);
                })}
            </Collapse>
            <Modal
                title="团队成员"
                visible={visible}
                footer={null}
                onCancel={() => {
                    setVisible(false), setGroupUrl(null);
                }}
            >
                {groupUrl && (
                    <PageGrid
                        ref={tableRef}
                        url={groupUrl}
                        columns={groupColumns}
                        rowKey="id"
                        paginationProps={{simple: true, showSizeChanger: false}}
                    />
                )}
            </Modal>
            <UserViewModal ref={viewRef} />
        </>
    );
}

const valueType = PropTypes.arrayOf(
    PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    })
);

SelectedPanel.propTypes = {
    selectedValues: PropTypes.shape({
        departs: valueType,
        users: valueType,
        tags: valueType,
    }),
    onDeleteSelected: PropTypes.func.isRequired,
};
